const classes = {
  hasMessage: 'has-message',
};

let textTimeout;

const init = () => {
  const mailtoLinks = document.querySelectorAll('a[href^="mailto:"]');
  const successMessage = document.body.dataset.clipboardCopied;
  let hasMessage = false;

  mailtoLinks.forEach(link => {
    const mailto = link.getAttribute('href');
    const mailtoAddress = mailto.split(':')[1];
    const label = link.innerText;

    link.addEventListener('mouseenter', () => {
      if (hasMessage) return;
      link.innerText = mailtoAddress;
    });

    link.addEventListener('mouseleave', () => {
      if (hasMessage) return;
      link.innerText = label;
    });

    link.addEventListener('pointerup', () => {
      clearTimeout(textTimeout);

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(mailtoAddress)
          .then(() => {
            link.innerText = successMessage;
            hasMessage = true;
            link.classList.add(classes.hasMessage);
            textTimeout = setTimeout(() => {
              link.innerText = label;
              link.classList.remove(classes.hasMessage);
              hasMessage = false;
            }, 2000);
          })
          .catch(err => {
            console.warn('Could not copy text: ', err);
          });
      }
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
